import "@fontsource-variable/geist";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ThemeProvider } from "./components/theme/theme-provider";
import { installAutomaticAppUpdates } from "./lib/app-update";
import "./index.css";

function scheduleOfflineCacheMaintenance(): void {
  if (typeof window === "undefined") {
    return;
  }

  const run = () => {
    void import("./lib/offline/offline-api-cache").then(
      ({ pruneOfflineApiResponses }) => pruneOfflineApiResponses(),
    );
  };

  const idleWindow = window as Window & {
    requestIdleCallback?: (
      callback: () => void,
      options?: { timeout: number },
    ) => number;
  };

  if (idleWindow.requestIdleCallback) {
    idleWindow.requestIdleCallback(run, { timeout: 4_000 });
    return;
  }

  window.setTimeout(run, 1_000);
}

scheduleOfflineCacheMaintenance();
installAutomaticAppUpdates();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider
    attribute="class"
    defaultTheme="dark"
    enableSystem
    disableTransitionOnChange
    storageKey="sparelynk-theme"
  >
    <App />
  </ThemeProvider>,
);
